import { ref } from 'vue'
import type { OptionType } from 'element-plus/es/components/select-v2/src/select.types.mjs'
import type { IPolicy } from '@/types/asicw/policies'

export function usePolicySelect() {
  const policySearchLoading = ref<boolean>(false)
  const policyOptions = ref<OptionType[]>([])

  const updatePolicyOptions = (policies: IPolicy[]) => {
    policyOptions.value = policies.map((policy: IPolicy) => ({
      label: `Policy #${policy.number}`,
      value: policy,
    }))
  }

  const clearPolicyOptions = () => {
    policyOptions.value = []
  }

  return {
    policySearchLoading,
    policyOptions,
    updatePolicyOptions,
    clearPolicyOptions,
  }
}
